import { useEffect, useRef, type FC } from 'react';
import { useLocation } from 'react-router-dom';

import { useConversaDaNyta } from '../../logica/nyta/useConversaDaNyta';
import { useDoMd } from '../padroes/useDoMd';
import { PainelDaNyta } from './PainelDaNyta';

// O painel é reexportado daqui: a vitrine e quem já o importava deste arquivo seguem iguais.
export { PainelDaNyta };

// A NYTA NO PAINEL DA DIREITA: no computador ela abre encostada à direita, abaixo do Header, como
// os painéis da conta e das notificações (pedido do Lucas, 27/09/2026), para a pessoa ver a conversa
// e o módulo ao mesmo tempo (decisão de 24/09/2026). Não é um diálogo modal: a página atrás continua
// usável. Esc fecha, e abrir outro painel do topo também. Na página da Nyta ela sai de cena (seria a
// mesma conversa duas vezes na tela).
//
// O uso do dia ("2 de 100 mensagens") mora embaixo do campo, e não no topo: ali ele espremia o nome
// do perfil.

// Um modal, uma lista aberta ou um balão por cima: o Esc é dele, e não do painel.
const temAlgoPorCima = () => !!document.querySelector('.cds--modal.is-visible, .cds--overflow-menu-options--open, .cds--popover--open, .cds--list-box--expanded');

export const NytaFlutuante: FC = () => {
  const { pathname } = useLocation();
  const c = useConversaDaNyta('flutuante');
  const titulo = useRef<HTMLHeadingElement>(null);
  const deOnde = useRef<HTMLElement | null>(null);
  const telaCheia = !useDoMd();
  const naPagina = /\/nyta$/.test(pathname);
  const { aberto, fechar } = c.painel;

  // Entrar na página da Nyta encerra o atalho: senão ele ressurgiria sozinho ao sair dela.
  useEffect(() => { if (naPagina && aberto) fechar(); }, [naPagina, aberto, fechar]);

  useEffect(() => {
    if (!aberto || naPagina) return undefined;
    // Quem abriu recebe o foco de volta ao fechar (o botão "Nyta IA" do topo, o de um módulo).
    deOnde.current = document.activeElement as HTMLElement | null;
    titulo.current?.focus();
    const esc = (e: KeyboardEvent) => { if (e.key === 'Escape' && !e.defaultPrevented && !temAlgoPorCima()) fechar(); };
    document.addEventListener('keydown', esc);
    return () => {
      document.removeEventListener('keydown', esc);
      const volta = deOnde.current;
      if (volta && document.contains(volta)) volta.focus();
    };
  }, [aberto, naPagina, fechar]);

  // No celular o painel cobre a tela inteira: o conteúdo atrás sai da ordem do Tab.
  useEffect(() => {
    const conteudo = document.getElementById('conteudo');
    if (!conteudo || !aberto || naPagina || !telaCheia) return undefined;
    conteudo.setAttribute('inert', '');
    return () => conteudo.removeAttribute('inert');
  }, [aberto, naPagina, telaCheia]);

  if (naPagina || !aberto) return null;
  return <PainelDaNyta c={c} focoNoTitulo={titulo} telaCheia={telaCheia} />;
};
